import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import ProductData from "../Data/ProductData.json";
const ProductSlider = () => {
  return (
    <>
      {/* <!-- Our Products Area --> */}
      <section className="products-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="p-sec-title">
                <h2 className="title-p">Our Products</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="products-slider owl-carousel">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={24}
                  slidesPerView={3}
                  navigation
                  loop={true}
                  autoplay={true}
                >
                  {ProductData.map((SingleProduct) => (
                    <SwiperSlide key={SingleProduct.id}>
                      {/* <!-- Single Slider --> */}
                      <div className="single-p-slider">
                        <div className="img-head">
                          <img src={SingleProduct.img} alt="#" />
                        </div>
                        <div className="product-content">
                          <h4 className="p-title">{SingleProduct.title}</h4>
                          <p>{SingleProduct.text}</p>
                          <div class="blog-btn">
                            <a
                              href={SingleProduct.url}
                              className="theme-btn primary"
                              target="_blank"
                            >
                              <i className="icofont-arrow-right"></i>Know more
                            </a>
                          </div>
                        </div>
                      </div>
                      {/* <!-- End Single Slider --> */}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Product Area --> */}
    </>
  );
};

export default ProductSlider;
